import React from 'react';
import './contactpage.css';
import { useNavigate } from 'react-router-dom';
import ContactForm from './contactform';

export const ContactPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-page">
      {/* Header */}
      <header className="contact-header">
        <div className="contact-header-content">
				<button className="back-link" onClick={() => { navigate(-1); }}>
					← Back
				</button>

          <div className="header-spacing"></div>
        </div>
      </header>

      {/* Main Content */}
      <div className="contact-container">
        <section className="contact-intro">
          <h1 className="contact-title">Get In Touch</h1>
          <p className="contact-subtitle">
            Looking for an experienced ID for your next home reno? Fill in the form below 
            or drop me a WhatsApp / email and I'll get back to you within 24 hours!
          </p>
        </section>

        {/* Contact Form */}
        <section className="contact-form-section">
          <div className="contact-form-wrapper">
            <ContactForm />
          </div>

          {/* Contact Info Sidebar */}
          <aside className="contact-info-sidebar">
            <div className="info-card">
              <h3>Reach out!</h3>
              <div className="info-item">
                <span className="info-label">Email:</span>
                <a href="mailto:cindy.ctconsultants@gmail.com" className="info-link">
                  cindy.ctconsultants@gmail.com
                </a>
              </div>
              <div className="info-item">
                <span className="info-label">Phone:</span>
                <a href="tel:+6590230750" className="info-link">
                  +65 9023 0750
                </a>
              </div>
            </div>
          </aside>
        </section>
      </div>
    </div>
  );
};
